import axios from "axios";
import { HOST_API_KEY } from "../../config";

const SEO_REQUEST_TIMEOUT_MS = 800;

export const getPlayFeed = async (params) => {
  const response = await axios.get(`${HOST_API_KEY}/play/feed`, { params });
  return response?.data;
};

export const getPlayVideos = async (params) => {
  const response = await axios.get(`${HOST_API_KEY}/play/videos`, { params });
  return response?.data;
};

export const getPlayReels = async (params) => {
  const response = await axios.get(`${HOST_API_KEY}/play/reels`, { params });
  return response?.data;
};

export const getPostById = async (postId) => {
  const response = await axios.get(`${HOST_API_KEY}/posts/${postId}`);
  return response?.data;
};

export const getPostByPublicId = async (publicId) => {
  const response = await axios.get(`${HOST_API_KEY}/posts/public/${publicId}`);
  return response?.data;
};
